import { Validator } from 'vee-validate';
import Api from '@/services';

Validator.extend(
  'uniqueness',
  {
    async validate(value, field) {
      if (!value || value.length === 0) return { valid: true };
      try {
        const isValid = await Api.User.validateFieldUniqueness(field, value);
        if (isValid) {
          return { valid: true };
        } else {
          return {
            valid: false,
            data: {
              message: `<strong>${value}</strong> is already in use. Please, use a different one.`,
            },
          };
        }
      } catch (error) {
        console.error(error);
        return { valid: false, data: { message: 'Unexpected error.' } };
      }
    },
    getMessage: (field, params, data) => {
      return (data && data.message) || 'Something went wrong';
    },
  },
  {
    immediate: false,
  }
);
